$('.rooms__more').click(function(event){
	let self = $(this);
	let rooms = self.parents('.rooms');
	self.slideUp(0);
	rooms.removeClass('rooms--grad');
	event.preventDefault();
});
